import type { paths } from '@orlikfy/api-interfaces';

export type { CreateUserPenaltyDto, CommonUserPenaltyDto, RevokeUserPenaltyResponseDto } from '@orlikfy/api-interfaces';

// DELETE /penalties/{userPenaltyId}
export const REVOKE_USER_PENALTY_PATH = '/penalties/{userPenaltyId}' as const satisfies keyof paths;
type RevokeUserPenaltyOperation = paths[typeof REVOKE_USER_PENALTY_PATH]['delete'];
export type RevokeUserPenaltyPathParams = RevokeUserPenaltyOperation['parameters']['path'];
export type RevokeUserPenaltyResponse =
  RevokeUserPenaltyOperation['responses']['default']['content']['application/json'];

// GET /user/{userId}/penalty
export const GET_USER_PENALTIES_PATH = '/user/{userId}/penalty' as const satisfies keyof paths;
type GetUserPenaltiesOperation = paths[typeof GET_USER_PENALTIES_PATH]['get'];
export type GetUserPenaltiesPathParams = GetUserPenaltiesOperation['parameters']['path'];
export type GetUserPenaltiesResponse = GetUserPenaltiesOperation['responses']['default']['content']['application/json'];

// POST /user/{userId}/penalty
export const CREATE_USER_PENALTY_PATH = '/user/{userId}/penalty' as const satisfies keyof paths;
type CreateUserPenaltyOperation = paths[typeof CREATE_USER_PENALTY_PATH]['post'];
export type CreateUserPenaltyPathParams = CreateUserPenaltyOperation['parameters']['path'];
export type CreateUserPenaltyBody = CreateUserPenaltyOperation['requestBody']['content']['application/json'];
